<template>
  <div class="d-flex align-items-center wrapper-title">
    <div class="d-flex align-items-center wrapper-text-help">
      <p class="child-reward-title duplicate-title mr-2">Duplicating Rewards</p>
      <question-popup
        popover-key="duplicate"
        variant="primary"
        :title="duplicatePopup['title']"
        :description="duplicatePopup['information']"
      />
    </div>
    <div>
      <div
        v-if="isDuplicateActivate"
        class="bg-main2 rounded-pill pl-3 btn-duplicate d-flex align-items-center"
      >
        <span class="text-white mr-2">Duplicate rewards for:</span>
        <b-button
          pill
          class="bg-white text-dark border-0 px-3 btn-duplicate-activate"
          id="popover-childrens"
          @click="showPopup = !showPopup"
        >
          <span class="mr-2">{{ childName }}</span>
          <b-icon icon="caret-down-fill"></b-icon>
        </b-button>
        <b-popover :show.sync="showPopup" target="popover-childrens" placement="bottomleft">
          <small class="text-black-50 font-weight-lighter">choose children to share</small>
          <div class="wrapper-childrens">
            <label
              class="wrapper-childrens-box"
              v-for="children in childrens"
              :key="children.value"
            >
              <span class="text-main font-weight-lighter">{{ children.text }}</span>
              <input
                type="checkbox"
                :value="children.value"
                v-model="childrensToDuplicateRewards"
              />
            </label>
          </div>
          <div class="container-btns">
            <b-button class="mb-2 duplicate-control-button" pill size="sm" @click="closeDuplicate"
              >Back</b-button
            >
            <b-button
              class="mb-2 duplicate-control-button"
              pill
              variant="warning"
              size="sm"
              @click="emitOnDuplicate"
              :disabled="disabledButtonShare"
              >Share</b-button
            >
          </div>
        </b-popover>
      </div>
      <b-button
        v-else
        pill
        variant="primary"
        class="btn-duplicate"
        @click="setIsDuplicateActivate(true)"
      >
        Duplicate rewards
      </b-button>
    </div>
  </div>
</template>
<script>
import QuestionPopup from '@/components/general/QuestionPopup.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  components: {
    QuestionPopup,
  },
  props: {
    childSelected: {
      type: Number,
      require: true,
    },
    duplicatePopup: {
      type: Object,
      default: () => ({ title: '', information: '' }),
    },
    childrens: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPopup: false,
      childrensToDuplicateRewards: [],
    };
  },
  methods: {
    ...mapMutations('rewards', ['setIsDuplicateActivate']),
    closeDuplicate() {
      this.childrensToDuplicateRewards = [];
      this.showPopup = !this.showPopup;
      this.setIsDuplicateActivate(false);
    },
    emitOnDuplicate() {
      this.$emit('on-duplicate', {
        childrenIds: [...this.childrensToDuplicateRewards],
        closeDuplicate: this.closeDuplicate,
      });
    },
  },
  computed: {
    ...mapState('rewards', ['isDuplicateActivate']),
    childName() {
      return this.childrens.find((child) => child.value === this.childSelected).text;
    },
    disabledButtonShare() {
      return !this.childrensToDuplicateRewards.length;
    },
  },
};
</script>
<style lang="scss" scope>
.wrapper-title {
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

@media (min-width: 768px) {
  .wrapper-title {
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 0;
  }
}

.btn-duplicate {
  box-shadow: 3px 3px 6px #00000029;
  background-color: #1e90ff !important;
  font-size: 0.9rem;

  &-activate {
    font-size: inherit;
    transform: scale(1.02);
  }
}

@media (min-width: 500px) {
  .btn-duplicate {
    font-size: 1rem;
  }
}

.wrapper-text-help {
  .wrapper-question-popover {
    color: #1e90ff;
  }
}
.wrapper-childrens {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  max-height: 200px;
  overflow: auto;
  @media (min-width: 500px) {
    max-height: 350px;
  }
  margin-bottom: 1rem;
  &-box {
    display: flex;
    justify-content: space-between;
    padding: 5px 8px;
    border: solid 1px #ccc;
    border-radius: 5px;
  }
}

.container-btns {
  display: flex;
  gap: 0.25rem;
}

.duplicate-control-button {
  flex-grow: 1;
}
</style>
